import { FC } from "react";
import Footer from "../footer";
import Navigator from "../navigator";
import styles from "./index.module.scss";

interface PageWrapperProps {
  children: React.ReactNode;
}

const PageWrapper: FC<PageWrapperProps> = ({ children }) => {
  return (
    <div className={styles.container}>
      <Navigator />
      <div className={styles.content}>{children}</div>
      <Footer />
    </div>
  );
};

export default PageWrapper;
